export default "__VITE_ASSET__DattpnHv__"